import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { AuthStoreType, AuthType } from './types'

const initialState = {
  token: '',
  userName: '',
  userSocialName: '',
  locale: '',
  baseUrl: '',
  id: '',
  ucode: '',
  expires_at: 0,
  authorities: [],
  tokenCreatedAt: 0,
  sid: '',
  email: '',
  profile: undefined
}

export const useAuthStore = create<AuthStoreType>()(
  devtools((set) => ({
    ...initialState,
    setAuth: (auth: AuthType): void => set({ ...auth }),
    resetAuth: (): void => set(initialState)
  }))
)
